export const RESPONSE_CHANNEL = "RESPONSE_CHANNEL";
export const RECEPTION_CHANNEL = "RECEPTION_CHANNEL";
export const blabla = {
    "error": {
        "status": false,
        "conflictValue":"0552283744",
        "entity": {
            "id":"4176c7d3-6607-4eea-bde8-9eaea6327154",
            "firstname":"Suzanne",
            "lastname":"Parent",
            "sexe":"F",
            "telephone": "[\"0552283744\"]",
            "email":"[\"tchauvin@example.org\"]",
            "ville":null,
            "id_card":null,
            "other_attributes":null,
            "created_at":"2020-05-20 12:14:23",
            "updated_at":"2020-05-20 12:14:23",
            "deleted_at":null
        },
        "message":"We found someone with the phone number : 0552283744 that you provide! Please, verify if it's the same that you want to register as the claimer"
    },
    "code":409
};
